<template>
  <div class="bodys" v-if="body_show">
    <div class="spell_top clearfix">
      <ul>
        <li class="on">
          <div class="spell_t spell_first">
            <img src="@a/spell.png" alt="" />
            <span></span>
          </div>
          <p>报名成功</p>
        </li>
        <li v-if="info.state" class="on">
          <div class="spell_t">
            <span></span>
            <img src="@a/spell.png" alt="" />
            <span></span>
          </div>
          <p>添加班主任微信</p>
        </li>
        <li v-else>
          <div class="spell_t">
            <span></span>
            <img src="@a/spell2.png" alt="" />
            <span></span>
          </div>
          <p>添加班主任微信</p>
        </li>
        <li>
          <div class="spell_t">
            <span></span>
            <img src="@a/spell3.png" alt="" />
            <span></span>
          </div>
          <p>邀请好友
            <br/>报名</p>
        </li>
        <li>
          <div class="spell_t">
            <span></span>
            <img src="@a/spell4.png" alt="" />
          </div>
          <p style="padding-left:26px;">返{{info.first_fee}}元
            <br/>佣金</p>
        </li>
      </ul>
    </div>
    <div class="spell_main">
      <h2>课程名称： <span>{{info.courseName}}</span></h2>
      <h2>支付金额： <span>¥{{info.missionPrice}}</span></h2>
      <h2>邀请规则： <span>每邀请1位好友报名，您将获得{{info.first_fee}}元现金红包！</span></h2>
    </div>
    <div class="pay"><router-link :to="info.state?'/teacher_code?course_id=' + course_id:'/training_information?course_id=' + course_id"> {{info.state?'查看班主任微信':'填写资料'}}</router-link></div>
    <div class="pays" @click="card_show=true">立即邀请好友<br/><span>（好友报名仅需{{info.missionPrice}}元）</span></div>
    <p class="zyzs">
      <router-link :to="'/invitation_progress?course_id=' + course_id + '&urlfrom=' + shimo_url">邀请进度>></router-link>
    </p>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
    <public-mobile ref="handle" @refiers="pullData" :train_pay="train_pay"></public-mobile>
  </div>
</template>
<script>
import {
  orderDetail
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        course_id: '',
        share: '',
        source: '',
        info: {},
        user: {},
        train_pay: {},
        card_show: false,
        time: null,
        type_obj: {},
        shimo_url: ''
      };
    },
    methods: {
      pullData() {
        this.course_id = this.$route.query.course_id;
        this.share = this.$route.query.share || 0;
        if(this.$route.query.source) {
          this.source = typeof this.$route.query.source == 'string' ? this.$route.query.source:this.$route.query.source[0];
        }
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        orderDetail({
            course_id: this.course_id
          })
          .then(data => {
            this.body_show = true;
            this.$toast.clear();
            // document.title = data.info.courseName;
            this.info = data.info;
            this.user = data.user;
            this.shimo_url = this.info.state?'filled_progress':'notfilled_progress';
            this.type_obj = {
              nickname: data.user.nickname,
              train_name: data.info.name,
              train_id: data.info.id,
              share: data.user.id
            };
            shareCon("training", this, this.type_obj);
          });
      }
    },
    created() {
      this.pullData();
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  text-align: center;
}

.spell_top {
  margin-top: 40px;
  padding: 0 40px;
  ul li {
    float: left;
    .spell_t {
      text-align: left;
      img {
        width: 80px;
      }
      span {
        width: 56px;
        height: 4px;
        background-color: #ccc;
        display: inline-block;
      }
    }
    .spell_first {
      margin-left: 10px;
    }
    p {
      line-height: 40px;
      color: #333;
      font-size: 27px;
      margin-top: 20px;
      text-align: center;
    }
  }
  ul li.on {
    .spell_t {
      span {
        background-color: #F57F17;
      }
    }
    p {
      color: #F57F17
    }
  }
}

.spell_main {
  margin: 0 30px;
  margin-top: 50px;
  padding: 20px 0;
  border-top: 2px solid #666;
  border-bottom: 2px solid #666;
  text-align: left;
  line-height: 40px;
  h2 {
    font-size: 26px;
    color: #666;
    span {
      color: #333;
      b {
        color: #EB5032
      }
    }
  }
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}

.pay {
  width: 578px;
  height: 80px;
  background: rgba(235, 80, 50, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 430px;
  color: #fff;
  font-size: 34px;
  line-height: 80px;
  a {
    color: #fff;
    display: block;
    width: 100%;
    height: 100%;
  }
}
.pays {
  width:578px;
  height:80px;
  background:rgba(255,255,255,1);
  border:2px solid rgba(235,80,50,1);
  border-radius:8px;
  color: #EB5032;
  font-size: 32px;
  padding-top: 2px;
  text-align: center;
  margin: 0 auto;
  margin-top: 30px;
  span {
    font-size: 22px;
    vertical-align: text-top;
  }
}

.zyz {
  color: #666;
  font-size: 26px;
  line-height: 40px;
  text-align: justify;
  padding: 0 30px;
}
.zyzs {
  margin-top: 20px;
  text-align: center;
  color: #666;
  font-size: 28px;
  a {
    color: #666
  }
}
</style>
